<template>
  <div :class="`container ${show ? 'show' : ''}`">
    <div class="flash"></div>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default {
  name: "Flash",
  data() {
    return {
      show: true
    };
  },
  mounted() {
    // scroll 禁止
    const body = document.querySelector("body");
    disableBodyScroll(body);
    document.querySelector("body").style["position"] = "fixed";

    setTimeout(() => {
      this.show = false;

      // scroll 禁止解除
      const body = document.querySelector("body");
      enableBodyScroll(body);
      document.querySelector("body").style["position"] = "";
    }, 1800);
  }
};
</script>

<style lang="scss">
@keyframes flash1 {
  0% {
    height: $flash-width;
    width: $flash-width;
    top: 50%;
    right: auto;
    bottom: auto;
    left: $flash-width;
    animation-timing-function: ease-in;
  }
  50% {
    height: 160px;
    width: $flash-width;
    top: 25%;
    right: auto;
    bottom: auto;
    left: $flash-width;
    animation-timing-function: ease-out;
  }
  100% {
    height: $flash-width;
    width: $flash-width;
    top: $flash-width;
    right: auto;
    bottom: auto;
    left: $flash-width;
  }
}

@keyframes flash2 {
  0% {
    height: $flash-width;
    width: $flash-width;
    top: $flash-width;
    right: calc(100vw - 16px);
    bottom: auto;
    left: auto;
    animation-timing-function: ease-in;
  }
  50% {
    height: $flash-width;
    width: 480px;
    top: $flash-width;
    right: 50vw;
    animation-timing-function: ease-out;
  }
  100% {
    height: $flash-width;
    width: $flash-width;
    top: $flash-width;
    right: $flash-width;
  }
}

@keyframes flash3 {
  0% {
    height: $flash-width;
    width: $flash-width;
    top: $flash-width;
    right: $flash-width;
    bottom: auto;
    left: auto;
    animation-timing-function: ease-in;
  }
  50% {
    height: 280px;
    width: $flash-width;
    top: 50vh;
    right: $flash-width;
    bottom: auto;
    left: auto;
    animation-timing-function: ease-out;
  }
  100% {
    height: $flash-width;
    width: $flash-width;
    top: calc(100vh - 16px);
    right: $flash-width;
    bottom: auto;
    left: auto;
  }
}

@keyframes flash4 {
  0% {
    height: $flash-width;
    width: $flash-width;
    top: auto;
    right: $flash-width;
    bottom: $flash-width;
    left: auto;
    animation-timing-function: ease-in;
  }
  50% {
    height: $flash-width;
    width: 480px;
    right: 50vw;
    bottom: $flash-width;
    animation-timing-function: ease-out;
  }
  100% {
    height: $flash-width;
    width: $flash-width;
    right: calc(100vw - 16px);
    bottom: $flash-width;
  }
}

@keyframes flash5 {
  0% {
    height: $flash-width;
    width: $flash-width;
    top: auto;
    right: auto;
    bottom: $flash-width;
    left: $flash-width;
    animation-timing-function: ease-in;
  }
  50% {
    height: 200px;
    width: $flash-width;
    bottom: 25%;
    left: $flash-width;
    animation-timing-function: ease-out;
  }
  100% {
    height: $flash-width;
    width: $flash-width;
    bottom: 50%;
    left: $flash-width;
  }
}

@keyframes flash6 {
  0% {
    height: $flash-width;
    width: $flash-width;
    top: auto;
    right: calc(100vw - 16px);
    bottom: 50%;
    left: auto;
    animation-timing-function: ease-in;
  }
  100% {
    height: $flash-width;
    width: 100vw;
    bottom: 50%;
    right: -200vw;
  }
}

@keyframes turnoff {
  from {
    opacity: 0;
    visibility: visible;
  }
}

.container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $color-black;
  z-index: 200;
  visibility: hidden;
  opacity: 0;
  transition: all 1.2s ease-in;

  &.show {
    visibility: visible;
    opacity: 1;
  }

  > .flash {
    background-color: #d4c4e8;
    position: absolute;
    border-radius: 999px;
    box-shadow: $shadow-neon-large;
    animation: flash1 0.2s, flash2 0.2s 0.2s, flash3 0.2s 0.4s, flash4 0.2s 0.6s,
      flash5 0.2s 0.8s, flash6 0.7s 1s, turnoff 10s 1.7s;
  }
}
</style>
